import React, { memo, useEffect, useState } from "react";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import PopupForm from "app/common/Component/Popup/PopupForm";
import {
  Button,
  Collapse,
  Grid,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import GlobitsMultiDatePicker from "app/common/form/GlobitsMultiDatePicker";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import { pagingDepartment } from "app/services/StoreRequestService";
import CommonButton from "app/common/Component/Button/CommonButton";
import { Block, Save, Search } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import TableComponent from "app/common/Component/Table/TableComponent";
import { renderBirthDate } from "app/TreatmentManagement/TreatmentListAll/TreatmentListAllData";
import {
  getDateTime,
  getDepartmentsUser,
  isAdmin,
} from "app/common/LocalFunction";
import { SERVICE_REQUEST_STATUS } from "app/common/LocalConst";
import { useFormikContext } from "formik";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import FilterListIcon from "@material-ui/icons/FilterList";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import * as Yup from "yup";

function CreateOrUpdateFolder({
  open,
  handleClose,
  initialValues,
  handleSubmit,
  patientId,
  handleAfterSubmit,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const validationSchema = Yup.object().shape({
    displayName: Yup.string()
      .nullable()
      .test(
        "required-folder",
        "Chưa nhập tên thư mục!",
        (val) => !(!Boolean(val) || val?.trim() === "")
      ),
  });
  return (
    <PopupForm
      size="sm"
      title={`${initialValues?.id ? "Chỉnh sửa" : "Tạo"}  thư mục`}
      open={open}
      handleClose={handleClose}
      formik={{
        initialValues: { patientId, ...initialValues },
        onSubmit: handleSubmit,
        validationSchema: validationSchema,
      }}
      action={({ isSubmitting, values }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton
              disabled={isSubmitting}
              // type="submit"
              className="btn-primary"
              onClick={async () => {
                let data = await handleSubmit(values);
                if (handleAfterSubmit && data) {
                  handleAfterSubmit();
                }
              }}
            >
              {!isMobile && <Save className="mr-2 " />}
              {initialValues?.id ? "Cập nhật" : "Tạo"} thư mục
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <GlobitsTextField
                  label="Tên thư mục"
                  name="folderName"
                  autoUpercase
                  required
                />
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <GlobitsTextField label="Ghi chú" name="note" isTextArea />
              </Grid>
            </Grid>
          </>
        );
      }}
    </PopupForm>
  );
}

export default memo(observer(CreateOrUpdateFolder));
